const buttonsStyle = {

  defaultButton: {
    width: 'auto',
    minWidth: 80,
    minHeight: 42,
    lineHeight: '42px',
    textAlign: 'center',
    padding: '0 12px',
    border: 0,
    float: 'right',
    marginBottom: 5,
    borderRadius: 28,
    cursor: 'pointer',
    '@media (max-width: 1365px)': {
      padding: '0 5px',
      minWidth: 80,
      fontSize: 12,
    },
  },
  activeButton: {
    width: 'auto',
    minWidth: 80,
    minHeight: 42,
    lineHeight: '42px',
    textAlign: 'center',
    padding: '0 12px',
    border: 0,
    float: 'right',
    marginLeft: 15,
    borderRadius: 20,
    marginBottom: 5,
    cursor: 'pointer',
    '& span': {
      color: '#fff !important',
    },
    '@media (max-width: 1365px)': {
      padding: '0 8px',
      minWidth: 80,
      fontSize: 12,
    },
    '@media (max-width: 600px)': {
      marginLeft: 0,
      float: 'left',
    },
  },
};

export default buttonsStyle;
